var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 29,
    viewBox: "0 0 11 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.19458 28.9994C0.833252 28.9834 1.427 28.663 1.79077 28.1354L10.4115 15.6354C10.8829 14.9519 10.8829 14.0481 10.4115 13.3645L1.79077 0.864563C1.427 0.337036 0.833252 0.0166016 0.19458 0.000610352V28.9994Z",
    fill: "#D0E2FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose);
export default __webpack_public_path__ + "static/media/Nose.f219e390.svg";
export { ForwardRef as ReactComponent };